import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { green, grey, red } from "@mui/material/colors";
import { InLakhsDisplay } from "../../ReusableComponents/InLakhsDisplay";
import { roundDecimalValueUptoTwo } from "../../../utils/roundDecimalValue";

export const normalFont = 14;
export const largeFont = 15;

export const DefRenderCellClass = {
	width: "100%",
	textAlign: "center",
	cursor: "pointer",
	minWidth: "100%",
	height: "100%",
	borderBottom: `2px solid ${grey[300]}`,
	display: "flex",
	justifyContent: "center",
	alignItems: "center",
};

export const DefRenderCell = ({ value, row, font }) => (
	<Box
		sx={{
			...DefRenderCellClass,
			fontWeight: row.isTotal ? "bold" : "normal",
			backgroundColor: row.isTotal ? "#000" : "inherit",
			color: row.isTotal ? "white" : grey[800],
			fontSize: font,
		}}>
		{typeof value === "number" ? roundDecimalValueUptoTwo(value) : value ?? 0}
	</Box>
);

/** Apply category-style cell chrome to plain column defs */
export const withCategoryCellLayout = (columns) =>
	(columns || []).map((col) => {
		if (col.renderCell) return col;
		const format = col.valueFormatter;
		return {
			...col,
			valueFormatter: undefined,
			renderCell: ({ row, value }) => (
				<DefRenderCell
					value={format ? format(value) : value}
					row={row}
					font={normalFont}
				/>
			),
		};
	});

/** Lighter cell layout for BP home / stores tables */
export const withHomeCellLayout = (columns) =>
	(columns || []).map((col) => {
		if (col.renderCell) return col;
		const format = col.valueFormatter;
		const isPrimary = col.field === "name" || col.field === "store_name";
		return {
			...col,
			valueFormatter: undefined,
			align: isPrimary ? "left" : col.align || "center",
			headerAlign: isPrimary ? "left" : col.headerAlign || "center",
			renderCell: ({ value }) => {
				const display = format ? format(value) : value;
				return (
					<Box
						sx={{
							width: "100%",
							overflow: "hidden",
							textOverflow: "ellipsis",
							whiteSpace: "nowrap",
							fontWeight: isPrimary ? 600 : 400,
							color: isPrimary ? grey[900] : grey[800],
							fontSize: isPrimary ? 13.5 : 13,
							textAlign: isPrimary ? "left" : "center",
						}}
					>
						{display === null || display === undefined || display === "" ? "—" : display}
					</Box>
				);
			},
		};
	});


export const TableInLakhsDisplay = ({ value, row, font }) => (
	<Box
		sx={{
			...DefRenderCellClass,
			fontWeight: row.isTotal ? "bold" : "normal",
			backgroundColor: row.isTotal ? "#000" : "inherit",
			color: row.isTotal ? "white" : grey[800],
			fontSize: font,
		}}>
		<InLakhsDisplay number={value} sx={{ fontWeight: "normal" }} />
	</Box>
);

export const QtyWithContribution = ({ value, row, type, totalQty }) => {
	const contri = roundDecimalValueUptoTwo((totalQty ? value / totalQty : 0) * 100);
	return (
		<Box
			sx={{
				width: "100%",
				textAlign: "center",
				borderBottom: `2px solid ${grey[300]}`,
				cursor: "pointer",
				fontWeight: row.isTotal ? "bold" : "normal",
				backgroundColor: row.isTotal ? "#000" : "inherit",
				color: row.isTotal ? "white" : grey[800],
				height: "100%",
				display: "flex",
				justifyContent: "space-around",
				alignItems: "center",
			}}>
			<Typography fontSize={type === "NEW" ? normalFont : largeFont} fontWeight={type === "NEW" ? "normal" : "bold"}>
				{value || 0}
			</Typography>
			<Typography fontSize={type === "NEW" ? normalFont - 2 : largeFont - 3} fontWeight={type === "NEW" ? "normal" : "bold"}>
				<span style={{ color: row.isTotal ? red[400] : type === "NEW" ? green[400] : red.A400 }}>
					{contri}%
				</span>
			</Typography>
		</Box>
	);
};

export const DiscountRenderCell = ({ row, type, value }) => (
	<Box
		sx={{
			cursor: "pointer",
			width: "100%",
			height: "100%",
			textAlign: "center",
			backgroundColor: row.isTotal ? "#000" : "inherit",
			color: row.isTotal ? "white" : grey[800],
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			fontWeight: row.isTotal ? "bold" : type === "NEW" ? "normal" : "bold",
			fontSize: type === "NEW" ? normalFont : largeFont,
			borderBottom: `2px solid ${grey[300]}`,
		}}>
		{value ? roundDecimalValueUptoTwo(value) : 0}
		<span style={{ fontWeight: "normal", fontSize: "14px" }}>%</span>
	</Box>
);
